import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { BasePerson } from '@/dtos/Persons/index';
import { HeartPulse, UserCheck, X } from 'lucide-react';

interface SelectedPersonDisplayProps {
  person: BasePerson;
  isEditMode: boolean;
  onDeselect: () => void;
}

export default function SelectedPersonDisplay({ person, isEditMode, onDeselect }: SelectedPersonDisplayProps) {
  return (
    <Card className='border-primary'>
      <CardHeader className='pb-3'>
        <div className='flex items-center justify-between'>
          <CardTitle className='flex items-center gap-2 text-lg text-primary'>
            <UserCheck className='h-5 w-5' />
            Persoană Selectată
          </CardTitle>
          <Button variant='ghost' size='sm' type='button' onClick={onDeselect}>
            <X className='h-4 w-4 mr-1' />
            Deselectează
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <div className='grid grid-cols-2 md:grid-cols-4 gap-4 text-sm'>
          <div>
            <span className='text-muted-foreground'>ID Intern:</span>
            <p className='font-medium font-mono'>{person.personInternalId || '-'}</p>
          </div>
          <div>
            <span className='text-muted-foreground'>Nume:</span>
            <p className='font-medium'>
              {person.firstName} {person.lastName}
            </p>
          </div>
          <div>
            <span className='text-muted-foreground'>Email:</span>
            <p className='font-medium'>{person.email || '-'}</p>
          </div>
          <div>
            <span className='text-muted-foreground'>Telefon:</span>
            <p className='font-medium'>{person.phone || '-'}</p>
          </div>
        </div>
        {person.healthProfile && (
          <div className='mt-4 pt-4 border-t'>
            <Badge variant='outline' className='gap-1'>
              <HeartPulse className='h-3 w-3' />
              Are profil de sănătate - poate fi modificat mai jos
            </Badge>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
